export const options_state_audience = [
  {value: true, label: '有効'},
  {value: false, label: '一時停止'},
]

export const options_state_setpoint = [
  {value: true, label: '有効'},
  {value: false, label: '一時停止'},
]
